/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Split_On_DashInputs */

const en_split_on_dash = /** @type {(inputs: Split_On_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split on Dash`)
};

const fr_split_on_dash = /** @type {(inputs: Split_On_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séparer sur le tiret`)
};

const de_split_on_dash = /** @type {(inputs: Split_On_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split on Dash`)
};

const it_split_on_dash = /** @type {(inputs: Split_On_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividi su Dash`)
};

const ru_split_on_dash = /** @type {(inputs: Split_On_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разделение на приборной панели`)
};

const es_split_on_dash = /** @type {(inputs: Split_On_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividir en el tablero`)
};

const zh_cn2_split_on_dash = /** @type {(inputs: Split_On_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`冲刺分`)
};

const ja_split_on_dash = /** @type {(inputs: Split_On_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダッシュで分割`)
};

const hi_split_on_dash = /** @type {(inputs: Split_On_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डैश पर विभाजित करें`)
};

const pt_pt2_split_on_dash = /** @type {(inputs: Split_On_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividir no painel`)
};

/**
* | output |
* | --- |
* | "Split on Dash" |
*
* @param {Split_On_DashInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const split_on_dash = /** @type {((inputs?: Split_On_DashInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Split_On_DashInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_split_on_dash(inputs)
	if (locale === "de") return de_split_on_dash(inputs)
	if (locale === "it") return it_split_on_dash(inputs)
	if (locale === "ru") return ru_split_on_dash(inputs)
	if (locale === "es") return es_split_on_dash(inputs)
	if (locale === "zh-CN") return zh_cn2_split_on_dash(inputs)
	if (locale === "ja") return ja_split_on_dash(inputs)
	if (locale === "hi") return hi_split_on_dash(inputs)
	if (locale === "pt-PT") return pt_pt2_split_on_dash(inputs)
	return en_split_on_dash(inputs)
});